// extracted by mini-css-extract-plugin
module.exports = {"bdgDefinition":"definition_bdgDefinition__3TgP0","bdgDefinitionContext":"definition_bdgDefinitionContext__mC_c6","badgeWithoutContent":"definition_badgeWithoutContent__T6Y_b"};